import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Grid, Row, Col } from 'react-bootstrap';

import { sendAnalytics } from 'utils/analyticsUtils';
import SpeakerProfile from './SpeakerProfile';
import SpeakerSessions from './SpeakerSessions';
import SpeakerTwitter from './TwitterTimeline';
import LoaderView from '../../LoaderView';
import { getRedirectUrl } from '../../../../selectors/EmailLoginSelectors';
import Utils from '../../Utils';
import { LoginWidgetScreen } from '@bizzabo/attendee-auth-api';
import FeatureToggleUtils from 'FeatureToggleUtils';
import EmailLoginContainer_Deprecated from '../../EmailLoginContainer_Deprecated';
import loadAccessibeWidget from '../../../../loadAccessibeWidget';
import VirtualVenueBanner from '../../VirtualVenueBanner';
import AttendeeLogin from '../../AttendeeLogin';
import SsoEmailErrorModal from '../../SsoEmailErrorModal';

export default class SpeakerView extends Component {
    static defaultProps = {
        speaker: null
    };
    static propTypes = {
        eventId: PropTypes.number.isRequired,
        speaker: PropTypes.object,
        speakerId: PropTypes.string,
        sessions: PropTypes.array.isRequired,
        goBack: PropTypes.func.isRequired,
        isWidget: PropTypes.bool.isRequired,
        likeSpeakerToggle: PropTypes.func.isRequired,
        fetchSpeakerData: PropTypes.func.isRequired,
        shouldFetchSpeaker: PropTypes.bool.isRequired,
        agendaUrl: PropTypes.string.isRequired,
        eventUrls: PropTypes.object,
        showEmailLogin: PropTypes.func.isRequired,
        siteConf: PropTypes.object,
        event: PropTypes.object,
        settings: PropTypes.object
    };

    isWebLoginUsed() {
        return !FeatureToggleUtils.isFeatureEnabled('oldLogin');
    }

    componentDidMount() {
        Utils.backgroundColorHandler('add');

        const {
            eventId,
            fetchSpeakerData,
            shouldFetchSpeaker,
            speakerId
        } = this.props;

        if (shouldFetchSpeaker) {
            fetchSpeakerData(eventId);
        }
        sendAnalytics('speakerPageView', {
            speakerId
        });
        FeatureToggleUtils.isFeatureEnabled('accessibeWidget') && loadAccessibeWidget();
    }

    componentWillUnmount() {
        Utils.backgroundColorHandler('remove');
    }

    renderEmailLoginOld() {
        const { props: { event: { id, groupId } } } = this;
        const redirectUrl = getRedirectUrl();

        return <EmailLoginContainer_Deprecated
            redirectUrl={redirectUrl}
            eventId={id}
            eventGroupId={groupId}
            headingText="Let's Get Started"
            subHeadingText="Enter the email used for event registration"
        />;
    }

    renderEmailLoginNew() {
        const redirectUrl = getRedirectUrl();

        return (
            <AttendeeLogin
                screen={LoginWidgetScreen.login}
                redirectUrl={redirectUrl}
            />
        );
    }

    render() {
        const { shouldFetchSpeaker, showEmailLogin, isEmailLoginShown, event, settings } = this.props;

        if (!this.isWebLoginUsed() && isEmailLoginShown) {
            return this.renderEmailLoginOld();
        }

        if (shouldFetchSpeaker) {
            return (
                <LoaderView />
            );
        }

        const {
            speaker: speakerData,
            speakerId,
            sessions,
            likeSpeakerToggle,
            goBack,
            isWidget,
            agendaUrl,
            eventUrls,
            siteConf,
            setLoginV2OffsetTop,
        } = this.props;
        const speaker = {
            ...speakerData,
            goBack,
            bio: {
                ...speakerData.bio,
                speakerCommunityLike: {
                    ...speakerData.bio.speakerCommunityLike,
                    likeSpeakerToggle: (isLiked) => {
                        sendAnalytics('speakerLikeAndUnlike', {
                            speakerId,
                        });
                        likeSpeakerToggle(speakerData.likeMarkerProps, isLiked);
                    }
                }
            }
        };
        const shortBackgroundHeight = sessions.length === 0 && speaker.twitterUsername === '';
        const bgCls = classnames(
            'speaker-background full-width custom-color',
            { 'short-background': shortBackgroundHeight }
        );
        const virtualVenueBannerClass = classnames({
            [`virtual-venue-banner--fixed virtual-venue-banner--speaker virtual-venue-banner--${siteConf.template}`]: !isWidget
        });

        return (
            <div className="speaker-view">
                {!siteConf.isWidget
                    && <VirtualVenueBanner customWrapperClass={virtualVenueBannerClass} />}
                <div className={bgCls} />
                <Grid className="speaker-container">
                    <SpeakerProfile
                        {...speaker}
                        showEmailLogin={showEmailLogin}
                        eventUrls={eventUrls}
                        event={event}
                        speakerId={speakerId}
                        siteConf={siteConf}
                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                    />
                    <Row className="speaker-sessions-twitter-wrapper">
                        <Col lg={12}>
                            {
                                !!sessions.length &&
                                <SpeakerSessions {...{ sessions, isWidget, agendaUrl, event, settings }} />
                            }
                            {
                                speaker.twitterUsername &&
                                <SpeakerTwitter twitterUsername={speaker.twitterUsername} />
                            }
                        </Col>
                    </Row>
                </Grid>
                {this.isWebLoginUsed() && isEmailLoginShown && this.renderEmailLoginNew()}
                <SsoEmailErrorModal />
            </div>
        );
    }
}

